import { render, staticRenderFns } from "./agentDependence.vue?vue&type=template&id=05464a1c&scoped=true&"
import script from "./agentDependence.vue?vue&type=script&lang=js&"
export * from "./agentDependence.vue?vue&type=script&lang=js&"
import style0 from "./agentDependence.vue?vue&type=style&index=0&id=05464a1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05464a1c",
  null
  
)

export default component.exports